interface PropsI {
	onClick?: () => void
}
export const CloseMinusIcon: React.FC<PropsI> = ({ onClick }) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='34'
		height='34'
		onClick={onClick}
		className='close-minus-icon-svg'
		viewBox='0 0 34 34'>
		<g id='Group_5005' data-name='Group 5005' transform='translate(-1698 -494)'>
			<rect
				id='Rectangle_168'
				data-name='Rectangle 168'
				width='34'
				height='34'
				rx='10'
				transform='translate(1698 494)'
				fill='#ff3067'
			/>
			<g
				id='_001-add'
				data-name='001-add'
				transform='translate(1724.292 520.575) rotate(180)'>
				<g id='Group_4463' data-name='Group 4463'>
					<path
						id='Path_3369'
						data-name='Path 3369'
						d='M17.291,7.719H1a1,1,0,0,0-1,1v.864a1,1,0,0,0,1,1h16.29a1,1,0,0,0,1-1V8.717A1,1,0,0,0,17.291,7.719Z'
						transform='translate(0 -0.002)'
						fill='#fff'
					/>
				</g>
			</g>
		</g>
	</svg>
)
